<ng-template #dropdownTemplate>
    <div
      class="phx-dropdown-content"
      (keydown)="onKeydown($event)">
      <ng-content></ng-content>
    </div>
</ng-template>
